import { render, staticRenderFns } from "./TreatmentsDirectoryGuide.vue?vue&type=template&id=ea479d56&scoped=true"
import script from "./TreatmentsDirectoryGuide.vue?vue&type=script&lang=js"
export * from "./TreatmentsDirectoryGuide.vue?vue&type=script&lang=js"
import style0 from "./TreatmentsDirectoryGuide.vue?vue&type=style&index=0&id=ea479d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea479d56",
  null
  
)

export default component.exports